import emailjs from 'emailjs-com';
import React, { useState } from 'react';
import { SiMinutemailer } from 'react-icons/si';
import Modal from 'react-modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    width: '350px',
    transform: 'translate(-50%, -50%)',
  },
};
function Contact() {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const contactStyles = {
    position: 'fixed',
    top: '50%',
    right: '3%',
    zIndex: '999999999',
  };

  const [contactData, setContactData] = useState({});
  const submitContactData = async (e) => {
    e.preventDefault();
    try {
      await emailjs.sendForm(
        'service_hujncnv',
        'template_sojvgy6',
        e.target,
        'user_E3nPmw6M1aWfu1mBn4AMM'
      );
      toast.success('Email Sent Successfully');
      closeModal();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div style={contactStyles}>
      <ToastContainer />
      <button className="btn rounded-circle bg-warning" onClick={openModal} type="button">
        {/* <img src={contactIcon} alt="" style={{ height: '45px' }} /> */}
        <SiMinutemailer style={{ fontSize: '25px', color: 'white' }} />
      </button>
      <Modal
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div>Email</div>
        <form onSubmit={submitContactData}>
          <div className="mb-3">
            <input
              required
              type="text"
              className="form-control"
              id="exampleFormControlInput22"
              placeholder="Name"
              name="name"
              onChange={(e) => setContactData({ ...contactData, userEmail: e.target.value })}
            />
            <input
              required
              type="email"
              className="form-control my-2"
              id="exampleFormControlInput21"
              name="email"
              placeholder="name@example.com"
              onChange={(e) => setContactData({ ...contactData, userEmail: e.target.value })}
            />
            <input
              required
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              name="subject"
              placeholder="Subject"
              onChange={(e) => setContactData({ ...contactData, userEmail: e.target.value })}
            />
          </div>
          <div>Write Your Query</div>
          <div className="mb-3">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              name="message"
              required
              onChange={(e) => setContactData({ ...contactData, query: e.target.value })}
            />
          </div>
          <button className="btn btn-warning" type="submit">
            Send
          </button>
          <button onClick={closeModal} type="button" className="btn btn-danger ms-5">
            close
          </button>
        </form>
      </Modal>
    </div>
  );
}

export default Contact;
